/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespTopModule_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_user">;
    readonly " $refType": "PdpRespTopModule_user";
};
export type PdpRespTopModule_user$data = PdpRespTopModule_user;
export type PdpRespTopModule_user$key = {
    readonly " $data"?: PdpRespTopModule_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTopModule_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '1927c99505d32894ee58bce4ea4e09c9';
export default node;
